import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Container } from "@/components/common/Primitives";
import { useLang } from "@/lib/i18n";
import { usePageMeta } from "@/lib/seo";

export default function NotFound() {
  const { tx } = useLang();
  usePageMeta("404");
  return (
    <Container className="py-24 lg:py-32" data-testid="not-found-page">
      <p className="text-sm font-medium text-muted-foreground tabular">404</p>
      <h1 className="mt-3 max-w-[16ch] text-[2.5rem] leading-[0.98] tracking-[-0.035em] text-foreground sm:text-[3.25rem]">{tx("Denne sida finst ikkje.", "This page does not exist.")}</h1>
      <p className="mt-4 max-w-md text-lg text-muted-foreground">{tx("Lenkja kan vere gamal, eller adressa er skriven feil.", "The link may be old, or the address was mistyped.")}</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Button asChild size="lg"><Link to="/">{tx("Til framsida", "Front page")}</Link></Button>
        <Button asChild size="lg" variant="soft"><Link to="/bestill">{tx("Bestill rom", "Book a room")} <ArrowRight className="h-4 w-4" /></Link></Button>
      </div>
    </Container>
  );
}
